import React from "react";
import classnames from "classnames";
import { translate } from "Shared/translate";
import { formatPrice } from "Shared/number-format";
import connect from "Shared/connect";
import * as styles from "./base.scss";
class Price extends React.PureComponent {
    render() {
        if (this.props.current === undefined || this.props.IsSupplierSalesman) {
            return null;
        }
        const props = this.props;
        const size = props.size || "normal";
        const baseProps = {
            className: classnames(styles.base, props.className, {
                [styles.small]: size === "small",
                [styles.medium]: size === "medium",
                [styles.large]: size === "large",
                [styles.huge]: size === "huge",
                [styles.gigantic]: size === "gigantic",
                [styles.isPending]: props.isPending,
            }),
        };
        const priceProps = {};
        const showSamllestUnitPrice = props.showAsSmallestUnitPrice &&
            !isNaN(props.smallestUnitPrice) &&
            props.smallestUnitPrice > 0;
        if (props.microData) {
            baseProps.itemProp = "offers";
            baseProps.itemType = "http://schema.org/Offer";
            baseProps.itemScope = true;
            priceProps.itemProp = "price";
        }
        const trackingProps = {
            "data-id": props.id,
            "data-discount": (props.original - props.current).toFixed(2),
        };
        return props.current !== null ? (React.createElement("span", Object.assign({}, baseProps, trackingProps),
            props.microData && (React.createElement("meta", { itemProp: "priceCurrency", content: translate("/Price/Currency") })),
            showSamllestUnitPrice && (React.createElement("span", { className: classnames(styles.current) },
                React.createElement("span", Object.assign({}, priceProps), formatPrice(props.smallestUnitPrice, props.formatAppearance)),
                React.createElement("span", { className: styles.unit },
                    props.currencySymbol,
                    props.priceUnit && " / " + translate("/Price/SmallestUnitPrice")))),
            React.createElement("span", { className: classnames(showSamllestUnitPrice ? styles.current_sup : styles.current) },
                React.createElement("span", Object.assign({}, priceProps), formatPrice(props.current, props.formatAppearance)),
                React.createElement("span", { className: classnames(styles.unit, "ui-test-unit-price") },
                    props.currencySymbol,
                    props.priceUnit && " / " + props.priceUnit)),
            !isNaN(props.comparison) && props.comparison > 0 && (React.createElement("span", { className: styles.comparePrice },
                translate("/Price/ComparisonPrice", formatPrice(props.comparison, props.formatAppearance)),
                !!props.comparisonPriceUnit && (React.createElement("span", null,
                    " ",
                    props.currencySymbol,
                    "/",
                    props.comparisonPriceUnit)))))) : (React.createElement("span", { className: classnames(styles.noPrice, props.noPriceClassName) }, translate("/Price/NoPriceAvailable")));
    }
}
export default connect((state) => ({
    IsSupplierSalesman: state.currentUser.isSupplierSalesman,
}), null)(Price);
